var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "va-row" }, [
    _c(
      "div",
      { staticClass: "flex md12 xs12" },
      [
        _c("vuestic-widget", [
          _c("div", { staticClass: "va-row" }, [
            _c("div", { staticClass: "flex" }, [
              _c(
                "button",
                {
                  staticClass: "btn btn-primary btn-micro",
                  on: { click: _vm.newUserData },
                },
                [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm._f("translate")("basic.button.confirm")) +
                      "\n          "
                  ),
                ]
              ),
            ]),
            _c("div", { staticClass: "flex" }, [
              _c(
                "button",
                {
                  staticClass: "btn btn-pale btn-micro",
                  on: {
                    click: function ($event) {
                      return _vm.$router.back(-1)
                    },
                  },
                },
                [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm._f("translate")("basic.button.cancel")) +
                      "\n          "
                  ),
                ]
              ),
            ]),
          ]),
        ]),
      ],
      1
    ),
    _c("div", { staticClass: "va-row" }, [
      _c(
        "div",
        { staticClass: "flex md12 xs12" },
        [
          _c(
            "vuestic-widget",
            {
              attrs: {
                headerText: _vm._f("translate")(
                  "userManagement.user.userInfomation.title"
                ),
              },
            },
            [
              _c("fieldset", [
                _c("div", { staticClass: "va-row" }, [
                  _c("div", { staticClass: "flex md6" }, [
                    _c("div", { staticClass: "form-group" }, [
                      _c("div", { staticClass: "input-group" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model.trim",
                              value: _vm.userForm.name,
                              expression: "userForm.name",
                              modifiers: { trim: true },
                            },
                          ],
                          attrs: {
                            id: "new_user_name",
                            maxlength: "128",
                            required: "",
                          },
                          domProps: { value: _vm.userForm.name },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) return
                              _vm.$set(
                                _vm.userForm,
                                "name",
                                $event.target.value.trim()
                              )
                            },
                            blur: function ($event) {
                              return _vm.$forceUpdate()
                            },
                          },
                        }),
                        _c(
                          "label",
                          {
                            staticClass: "control-label",
                            attrs: { for: "new_user_name" },
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm._f("translate")(
                                  "userManagement.user.userInfomation.name"
                                )
                              )
                            ),
                          ]
                        ),
                        _c("i", { staticClass: "bar" }),
                      ]),
                    ]),
                  ]),
                  _c("div", { staticClass: "flex md6" }, [
                    _c(
                      "div",
                      {
                        staticClass: "form-group with-icon-right",
                        class: {
                          "has-error": _vm.errors.has("userEmail"),
                          valid: _vm.simpleEmailValid,
                        },
                      },
                      [
                        _c("div", { staticClass: "input-group" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model.trim",
                                value: _vm.userForm.email,
                                expression: "userForm.email",
                                modifiers: { trim: true },
                              },
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: "email|validateEmail",
                                expression: "'email|validateEmail'",
                              },
                            ],
                            attrs: {
                              id: "new_user_email",
                              name: "userEmail",
                              autocomplete: "off",
                              maxlength: "100",
                            },
                            domProps: { value: _vm.userForm.email },
                            on: {
                              focus: _vm.changeLabelUp,
                              blur: [
                                _vm.changeLabelBase,
                                function ($event) {
                                  return _vm.$forceUpdate()
                                },
                              ],
                              input: function ($event) {
                                if ($event.target.composing) return
                                _vm.$set(
                                  _vm.userForm,
                                  "email",
                                  $event.target.value.trim()
                                )
                              },
                            },
                          }),
                          _c("i", {
                            staticClass:
                              "fa fa-exclamation-triangle error-icon icon-right input-icon",
                          }),
                          _c(
                            "label",
                            {
                              staticClass: "control-label",
                              attrs: { id: "newEmail", for: "userEmail" },
                            },
                            [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(
                                    _vm._f("translate")(
                                      "userManagement.user.userInfomation.email"
                                    )
                                  ) +
                                  "：\n                  "
                              ),
                            ]
                          ),
                          _c("i", { staticClass: "bar" }),
                          _c(
                            "small",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.errors.has("userEmail"),
                                  expression: "errors.has('userEmail')",
                                },
                              ],
                              staticClass: "help text-danger",
                            },
                            [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(_vm.errors.first("userEmail")) +
                                  "\n                  "
                              ),
                            ]
                          ),
                        ]),
                      ]
                    ),
                  ]),
                  _c("div", { staticClass: "flex md6" }, [
                    _c(
                      "div",
                      {
                        staticClass: "form-group",
                        staticStyle: { "margin-bottom": "0" },
                      },
                      [
                        _c("div", { staticClass: "input-group" }, [
                          (_vm.isNewOpen ? "text" : "password") === "checkbox"
                            ? _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.userForm.password,
                                    expression: "userForm.password",
                                  },
                                ],
                                attrs: {
                                  id: "new_user_password",
                                  maxlength: "50",
                                  required: "",
                                  onkeyup: "value=value.replace(/\\s/g,'')",
                                  onkeydown: "value=value.replace(/\\s/g,'')",
                                  type: "checkbox",
                                },
                                domProps: {
                                  checked: Array.isArray(_vm.userForm.password)
                                    ? _vm._i(_vm.userForm.password, null) > -1
                                    : _vm.userForm.password,
                                },
                                on: {
                                  keydown: (e) => {
                                    if (e.keyCode == 32) e.returnValue = false
                                  },
                                  change: function ($event) {
                                    var $$a = _vm.userForm.password,
                                      $$el = $event.target,
                                      $$c = $$el.checked ? true : false
                                    if (Array.isArray($$a)) {
                                      var $$v = null,
                                        $$i = _vm._i($$a, $$v)
                                      if ($$el.checked) {
                                        $$i < 0 &&
                                          _vm.$set(
                                            _vm.userForm,
                                            "password",
                                            $$a.concat([$$v])
                                          )
                                      } else {
                                        $$i > -1 &&
                                          _vm.$set(
                                            _vm.userForm,
                                            "password",
                                            $$a
                                              .slice(0, $$i)
                                              .concat($$a.slice($$i + 1))
                                          )
                                      }
                                    } else {
                                      _vm.$set(_vm.userForm, "password", $$c)
                                    }
                                  },
                                },
                              })
                            : (_vm.isNewOpen ? "text" : "password") === "radio"
                            ? _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.userForm.password,
                                    expression: "userForm.password",
                                  },
                                ],
                                attrs: {
                                  id: "new_user_password",
                                  maxlength: "50",
                                  required: "",
                                  onkeyup: "value=value.replace(/\\s/g,'')",
                                  onkeydown: "value=value.replace(/\\s/g,'')",
                                  type: "radio",
                                },
                                domProps: {
                                  checked: _vm._q(_vm.userForm.password, null),
                                },
                                on: {
                                  keydown: (e) => {
                                    if (e.keyCode == 32) e.returnValue = false
                                  },
                                  change: function ($event) {
                                    return _vm.$set(
                                      _vm.userForm,
                                      "password",
                                      null
                                    )
                                  },
                                },
                              })
                            : _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.userForm.password,
                                    expression: "userForm.password",
                                  },
                                ],
                                attrs: {
                                  id: "new_user_password",
                                  maxlength: "50",
                                  required: "",
                                  onkeyup: "value=value.replace(/\\s/g,'')",
                                  onkeydown: "value=value.replace(/\\s/g,'')",
                                  type: _vm.isNewOpen ? "text" : "password",
                                },
                                domProps: { value: _vm.userForm.password },
                                on: {
                                  keydown: (e) => {
                                    if (e.keyCode == 32) e.returnValue = false
                                  },
                                  input: function ($event) {
                                    if ($event.target.composing) return
                                    _vm.$set(
                                      _vm.userForm,
                                      "password",
                                      $event.target.value
                                    )
                                  },
                                },
                              }),
                          _c(
                            "label",
                            {
                              staticClass: "control-label",
                              attrs: { for: "new_user_password" },
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm._f("translate")(
                                    "userManagement.user.userInfomation.password"
                                  )
                                )
                              ),
                            ]
                          ),
                          _c("i", { staticClass: "bar" }),
                          _c("div", { staticClass: "eye-password" }, [
                            !_vm.isNewOpen
                              ? _c("img", {
                                  attrs: { src: _vm.closeEye, alt: "" },
                                  on: {
                                    click: () => {
                                      _vm.isNewOpen = true
                                    },
                                  },
                                })
                              : _vm._e(),
                            _vm.isNewOpen
                              ? _c("img", {
                                  attrs: { src: _vm.openEye, alt: "" },
                                  on: {
                                    click: () => {
                                      _vm.isNewOpen = false
                                    },
                                  },
                                })
                              : _vm._e(),
                          ]),
                        ]),
                      ]
                    ),
                  ]),
                  _c("div", { staticClass: "flex md6" }, [
                    _c(
                      "div",
                      {
                        staticClass: "form-group",
                        staticStyle: { "margin-bottom": "0" },
                      },
                      [
                        _c("div", { staticClass: "input-group" }, [
                          (_vm.isRepOpen ? "text" : "password") === "checkbox"
                            ? _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.userForm.repeat_password,
                                    expression: "userForm.repeat_password",
                                  },
                                ],
                                attrs: {
                                  id: "new_user_repeat_password",
                                  maxlength: "50",
                                  required: "",
                                  onkeyup: "value=value.replace(/\\s/g,'')",
                                  onkeydown: "value=value.replace(/\\s/g,'')",
                                  type: "checkbox",
                                },
                                domProps: {
                                  checked: Array.isArray(
                                    _vm.userForm.repeat_password
                                  )
                                    ? _vm._i(
                                        _vm.userForm.repeat_password,
                                        null
                                      ) > -1
                                    : _vm.userForm.repeat_password,
                                },
                                on: {
                                  keydown: (e) => {
                                    if (e.keyCode == 32) e.returnValue = false
                                  },
                                  change: function ($event) {
                                    var $$a = _vm.userForm.repeat_password,
                                      $$el = $event.target,
                                      $$c = $$el.checked ? true : false
                                    if (Array.isArray($$a)) {
                                      var $$v = null,
                                        $$i = _vm._i($$a, $$v)
                                      if ($$el.checked) {
                                        $$i < 0 &&
                                          _vm.$set(
                                            _vm.userForm,
                                            "repeat_password",
                                            $$a.concat([$$v])
                                          )
                                      } else {
                                        $$i > -1 &&
                                          _vm.$set(
                                            _vm.userForm,
                                            "repeat_password",
                                            $$a
                                              .slice(0, $$i)
                                              .concat($$a.slice($$i + 1))
                                          )
                                      }
                                    } else {
                                      _vm.$set(
                                        _vm.userForm,
                                        "repeat_password",
                                        $$c
                                      )
                                    }
                                  },
                                },
                              })
                            : (_vm.isRepOpen ? "text" : "password") === "radio"
                            ? _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.userForm.repeat_password,
                                    expression: "userForm.repeat_password",
                                  },
                                ],
                                attrs: {
                                  id: "new_user_repeat_password",
                                  maxlength: "50",
                                  required: "",
                                  onkeyup: "value=value.replace(/\\s/g,'')",
                                  onkeydown: "value=value.replace(/\\s/g,'')",
                                  type: "radio",
                                },
                                domProps: {
                                  checked: _vm._q(
                                    _vm.userForm.repeat_password,
                                    null
                                  ),
                                },
                                on: {
                                  keydown: (e) => {
                                    if (e.keyCode == 32) e.returnValue = false
                                  },
                                  change: function ($event) {
                                    return _vm.$set(
                                      _vm.userForm,
                                      "repeat_password",
                                      null
                                    )
                                  },
                                },
                              })
                            : _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.userForm.repeat_password,
                                    expression: "userForm.repeat_password",
                                  },
                                ],
                                attrs: {
                                  id: "new_user_repeat_password",
                                  maxlength: "50",
                                  required: "",
                                  onkeyup: "value=value.replace(/\\s/g,'')",
                                  onkeydown: "value=value.replace(/\\s/g,'')",
                                  type: _vm.isRepOpen ? "text" : "password",
                                },
                                domProps: {
                                  value: _vm.userForm.repeat_password,
                                },
                                on: {
                                  keydown: (e) => {
                                    if (e.keyCode == 32) e.returnValue = false
                                  },
                                  input: function ($event) {
                                    if ($event.target.composing) return
                                    _vm.$set(
                                      _vm.userForm,
                                      "repeat_password",
                                      $event.target.value
                                    )
                                  },
                                },
                              }),
                          _c(
                            "label",
                            {
                              staticClass: "control-label",
                              attrs: { for: "new_user_repeat_password" },
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm._f("translate")(
                                    "userManagement.user.userInfomation.repeat_password"
                                  )
                                )
                              ),
                            ]
                          ),
                          _c("i", { staticClass: "bar" }),
                          _c("div", { staticClass: "eye-password" }, [
                            !_vm.isRepOpen
                              ? _c("img", {
                                  attrs: { src: _vm.closeEye, alt: "" },
                                  on: {
                                    click: () => {
                                      _vm.isRepOpen = true
                                    },
                                  },
                                })
                              : _vm._e(),
                            _vm.isRepOpen
                              ? _c("img", {
                                  attrs: { src: _vm.openEye, alt: "" },
                                  on: {
                                    click: () => {
                                      _vm.isRepOpen = false
                                    },
                                  },
                                })
                              : _vm._e(),
                          ]),
                        ]),
                      ]
                    ),
                  ]),
                  _c(
                    "div",
                    {
                      staticClass: "form-group with-icon-right",
                      staticStyle: { "margin-left": "10px" },
                    },
                    [
                      _vm._v(
                        "\n              " +
                          _vm._s(_vm.$t("t.passwordMustBe")) +
                          "\n            "
                      ),
                    ]
                  ),
                ]),
              ]),
            ]
          ),
          _c(
            "vuestic-widget",
            {
              attrs: {
                headerText: _vm._f("translate")(
                  "userManagement.user.authority.title"
                ),
                id: "formAuthority",
              },
            },
            [
              _c(
                "fieldset",
                [
                  _c("div", { staticClass: "flex md12 xs12" }, [
                    _c(
                      "div",
                      {
                        staticStyle: {
                          "border-width": "0px 0px 1px 0px",
                          "border-style": "solid",
                          "border-color": "rgba(204, 204, 204, 1)",
                        },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm._f("translate")(
                                "userManagement.user.authority.pages.title"
                              )
                            )
                          ),
                        ]),
                      ]
                    ),
                  ]),
                  _vm._l(_vm.userForm.pages, function (page, index) {
                    return _c(
                      "div",
                      { key: index, staticClass: "flex md12 xs12" },
                      [
                        _c("div", { staticClass: "va-row" }, [
                          _c("div", { staticClass: "flex md4 p-l" }, [
                            _c("label", [
                              _vm._v(_vm._s(_vm.translatePageName(page.name))),
                            ]),
                          ]),
                          _c("div", { staticClass: "flex md2" }),
                          _c(
                            "div",
                            { staticClass: "flex md4" },
                            [
                              _c("vuestic-checkbox", {
                                staticStyle: {
                                  display: "inline-flex",
                                  width: "100px",
                                },
                                attrs: { label: _vm.$t("view") },
                                model: {
                                  value: _vm.createItems[index].privileges[0],
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.createItems[index].privileges,
                                      0,
                                      $$v
                                    )
                                  },
                                  expression:
                                    "createItems[index].privileges[0]",
                                },
                              }),
                            ],
                            1
                          ),
                          _c("div", { staticClass: "flex md2" }),
                        ]),
                      ]
                    )
                  }),
                  _c("div", { staticClass: "flex md12 xs12" }, [
                    _c(
                      "div",
                      {
                        staticStyle: {
                          "border-width": "0px 0px 1px 0px",
                          "border-style": "solid",
                          "border-color": "rgba(204, 204, 204, 1)",
                        },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm._f("translate")(
                                "userManagement.user.authority.apps.title"
                              )
                            )
                          ),
                        ]),
                      ]
                    ),
                  ]),
                  _c("div", { staticClass: "va-row" }, [
                    _c("div", { staticClass: "flex md1 xs1" }),
                    _c(
                      "div",
                      { staticClass: "flex md10 xs10" },
                      [
                        _c("vuestic-multi-select", {
                          attrs: {
                            label: _vm.$t(
                              "userManagement.user.authority.apps.selectDuplicate"
                            ),
                            optionKey: "app_name",
                            clearable: "",
                            options: _vm.appList,
                          },
                          model: {
                            value: _vm.selectApps,
                            callback: function ($$v) {
                              _vm.selectApps = $$v
                            },
                            expression: "selectApps",
                          },
                        }),
                        _c("div", { staticClass: "flex md1 xs1" }),
                      ],
                      1
                    ),
                  ]),
                ],
                2
              ),
            ]
          ),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }